import React from 'react';
import {
  Container,
  makeStyles
} from '@material-ui/core';
import Page from '../../../../components/global/Page';
import NotificationSettings from './NotificationSettings';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const NotificationSettingsView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Notification Settings"
    >
      <Container maxWidth="lg">
        <NotificationSettings />
      </Container>
    </Page>
  );
};

export default NotificationSettingsView;
